import { cpqAxios, cpqAxiosWithToken } from '../http-common';
import { Congiguration } from '../Constants/AppConstants';

class ProductService {

    getProductDetails() {

        return cpqAxiosWithToken.get(`ProductDetails/GetProductDetails/?companyId=${Congiguration.CompanyId}`);
    }

}

export default new ProductService();